import React, { useState } from 'react';
import styled from 'styled-components';

interface IPalette {
  bgColor: string;
  color: string;
}

const EnvDiv = styled.div<{ palette: IPalette }>`
  font-size: 16px;
  width: 100%;
  text-align: center;
  border: 0;
  padding: 0;
  position: fixed;
  top: 0;
  z-index: 1000000;
  background-color: ${({ palette }) => palette.bgColor};
  color: ${({ palette }) => palette.color};
`;

interface Props {
  env: string;
  children: any;
}

const PALETTES: Record<string, IPalette> = {
  dev: { bgColor: '#FFFF88', color: '#333' },
  stg: { bgColor: '#D8C8FF', color: '#333' },
  ins: { bgColor: '#bf0000', color: '#fff' },
};

export const EnvBar = (props: Props) => {
  const [isShown, setIsShown] = useState(true);
  const { env, children } = props;
  if (!isShown || !env || ['unknown', 'pro'].includes(env)) {
    return null;
  }
  const palette = PALETTES[env] || PALETTES.dev;
  return (
    <EnvDiv
      className={'envBar'}
      palette={palette}
      onClick={() => setIsShown(false)}
    >
      <span style={{ marginRight: '10px' }}>{env.toUpperCase()}</span>
      {children}
    </EnvDiv>
  );
};
